import accordions from './components/accordions';
import bookmark from './components/bookmark';
import accountDeleteConfirmation from './components/accountDeleteConfirmation';
import accountMenuToggle from './components/accountMenuToggle';
import mobileMenuToggle from './components/mobileMenuToggle';
import progressConfetti from './components/progressConfetti';
import progressSteps from './components/progressSteps';
import registerForm from './components/registerForm';
import copyVideoLink from './components/copyVideoLink';
import toggleVideoVersion from './components/toggleVideoVersion';
import highlightSidebar from './components/highlightSidebar'
import slideshow from './components/slideshow';
import scrollNavBar from './components/scrollNavBar';
import checkAnswers from './components/checkAnswers';
import gradeExam from './components/gradeExam';
import scrollArticle from './components/scrollArticle';
import trackEvents from './components/trackEvents';
import filterPublications from './components/filterPublications';
import filterCourses from './components/filterCourses';
import collapsibleChapter from './components/collapsibleChapter';

window.addEventListener("DOMContentLoaded", () => {
  // Main menu, mobile toggle
  mobileMenuToggle();

  // Front page
  slideshow();

  // My account settings page
  accountDeleteConfirmation();
  accountMenuToggle();

  // User registration
  registerForm();

  // Course overview page
  progressSteps();
  progressConfetti();
  collapsibleChapter();

  // Course pages, page functions
  accordions();
  bookmark();
  checkAnswers();
  copyVideoLink();
  toggleVideoVersion();

  // Course pages, sidebar and nav
  scrollNavBar();
  highlightSidebar();
  scrollArticle();

  // Test
  gradeExam();

  // Tracking
  trackEvents();

  //Filter data
  filterPublications();
  filterCourses();

  // Adding ARIA role to cookie banner for better accessibility
  const banner = document.querySelector('.eu-cookies-bar-cookies-bar-wrap'); // find class or ID the banner uses
  if (banner) {
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-label', 'Cookie Banner');
  }
  const cookieSettingsLink = document.querySelector('.eu-cookies-bar-cookies-settings-call-container'); // find class or ID the link uses
  if (cookieSettingsLink) {
    cookieSettingsLink.setAttribute('role', 'dialog');
    cookieSettingsLink.setAttribute('aria-label', 'Cookie Settings');
  }

});
